export default __webpack_public_path__ + "static/media/logo-cqc.73fdd1c8.png";